import React, { useRef, useState, useEffect } from 'react'
import emailjs from '@emailjs/browser';
import EmailSent from './EmailSent';


const Form = () => {

    const form = useRef();


    const [emailSentScreen, setEmailSentScreen] = useState(false);

    const template_id = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

    const public_key = process.env.REACT_APP_EMAILJS_PUBLIC_KEY

    const service_id = process.env.REACT_APP_EMAILJS_SERVICE_ID

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(service_id, template_id, form.current, public_key)
            .then(
                (result) => {
                    console.log('Email sent!', result.text);
                    setEmailSentScreen(true);
                    form.current.reset();
                },
                (error) => {
                    console.log('Failed to send email:', error.text);
                }
            );
    };




    useEffect(() => {
        if (emailSentScreen) {

            document.body.style.overflow = 'hidden';

        } else {

            document.body.style.overflow = '';

        }

        return () => {
            document.body.style.overflow = '';

        };
    }, [emailSentScreen]);







    return (
        <div className='form-margin'>
            {emailSentScreen && <EmailSent closeScreen={() => setEmailSentScreen(false)} />}


            <h2 className='consultation'>REQUEST A FREE CONSULTATION</h2>
            <p className="q">Or ask us any questions</p>

            <div id="form-main">
                <img id='email-graphic' src="images/email-img-2.png" alt='email icon' />
                <form ref={form} id="form-1" onSubmit={sendEmail}>
                    <div className="input-holder input-holder-normal">

                        <input placeholder='' id="fullname" className="form-input" type="text" name="fullName" required />
                        <label className="lbl" htmlFor="name">Full Name</label>
                    </div>


                    <div id='email-phone'>
                        <div className="input-holder input-holder-emailphone">

                            <input placeholder='' id="email" className="form-input" type="email" name="email" required />
                            <label className="lbl" htmlFor="email">Email</label>
                        </div>

                        <div className="input-holder input-holder-emailphone">

                            <input placeholder='' id="Phone" className="form-input" type="tel" name="phone" required />

                            <label className="lbl" htmlFor="phone">Phone#</label>
                        </div>

                    </div>


                    <div className="input-holder input-holder-normal">

                        <input placeholder='' id="subject" className="form-input" type="text" name="subject" required />
                        <label className="lbl" htmlFor="subject">Subject</label>
                    </div>


                    <div className="input-holder input-holder-text-area">

                        <textarea placeholder='' className="input-message" name="message" required></textarea>

                        <label className="lbl-message" htmlFor="message">Message</label>
                    </div>


                    <button type='submit' className="form-btn " id="form-btn-1">Send</button>
                </form>
            </div>
        </div>
    )
}

export default Form